var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      staticStyle: { width: "150px" },
      attrs: {
        clearable: "",
        filterable: "",
        placeholder: "Sélection",
        size: "mini"
      },
      on: {
        change: function($event) {
          return _vm.onChange($event)
        },
        clear: function($event) {
          return _vm.onClear()
        }
      },
      model: {
        value: _vm.LibelleFacture,
        callback: function($$v) {
          _vm.LibelleFacture = $$v
        },
        expression: "LibelleFacture"
      }
    },
    _vm._l(_vm.LibelleFactureList, function(item) {
      return _c(
        "el-option",
        {
          key: item.id,
          attrs: { label: item.libelle, value: item.id, disabled: !item.actif }
        },
        [
          _c("span", { staticStyle: { float: "left" } }, [
            _vm._v(_vm._s(item.libelle))
          ])
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }